import { InfoIcon } from "../../../svg/info-icon";

const ErrorComponent = () => {
  return (
    <div className="error-container flex h-full w-full flex-col items-center justify-center gap-2">
      <div className="error-icon">
        <InfoIcon stroke="red" height={"48"} width={"48"} />
      </div>
      <div className="error-message">
        <div className="text-h11 font-semiBold text-primaryGray-1">
          Something went wrong!
        </div>{" "}
        <div className="text-h14 text-gray-600">
          Failed to load draft submissions details. Please try again later.
        </div>{" "}
      </div>
    </div>
  );
};

export default ErrorComponent;
